module.exports = __webpack_public_path__ + "assets/img/recommendation.635c2169.png";